/* ==========================================================================
   Satjeevan — Main Product Information gallery entrance transition
   (main-product-gallery-transition.js)

   assets/media-gallery.js (Horizon) replaces the whole <media-gallery>
   element wholesale on variant change — an instant DOM swap with no
   animation. This watches for that swap (via MutationObserver, so it
   doesn't need to race Horizon's own internal event timing) and plays a
   quick fade-in on the freshly inserted MAIN IMAGE only, so the new
   variant's photo settles in smoothly instead of snapping into place.

   Deliberately scoped to .sj-mpi-main-wrap, not the whole gallery: the
   thumbnail rail lives inside the same replaced <media-gallery> element,
   but its content barely changes between variants (same set, just
   reordered/re-highlighted) — animating it too just made already-correct
   thumbnails flash for no reason, which read as a glitch rather than a
   transition.

   Purely a visual entrance effect — no state is read from or restored onto
   the new gallery (see the removed main-product-gallery-sync.js this
   replaced: that one tried to preserve gallery position across swaps, but
   that fought against always showing the new variant's own primary image,
   which is what's actually wanted here).
   ========================================================================== */

(function () {
  'use strict';

  var INIT_ATTR = 'data-sj-mpi-gallery-transition-init';
  var ENTER_CLASS = 'sj-mpi-gallery-swap-enter';

  function animateIn(gallery) {
    var mainWrap = gallery.querySelector('.sj-mpi-main-wrap');
    if (!mainWrap) return;

    mainWrap.classList.add(ENTER_CLASS);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        mainWrap.classList.remove(ENTER_CLASS);
      });
    });
  }

  function watchGallery(gallery) {
    var parent = gallery.parentElement;
    if (!parent || parent.hasAttribute(INIT_ATTR)) return;
    parent.setAttribute(INIT_ATTR, '1');

    var observer = new MutationObserver(function (mutationsList) {
      mutationsList.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1 && node.tagName === 'MEDIA-GALLERY') {
            animateIn(node);
          }
        });
      });
    });

    observer.observe(parent, { childList: true });
  }

  function init() {
    document.querySelectorAll('.sj-mpi-gallery-col media-gallery').forEach(watchGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
